var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "02d908f8a7a2da6bd1d13027b8bf8d724cad9bc4"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["idataworkers-newwebsite@icloudready"] = {
  id: "02d908f8a7a2da6bd1d13027b8bf8d724cad9bc4"
};